import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  OnDestroy,
  signal,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SecondaryButton } from '@components/button/secondary-button/secondary-button';

@Component({
  selector: 'app-copyable-log-field',
  standalone: true,
  imports: [TranslateModule, SecondaryButton],
  templateUrl: './copyable-log-field.html',
  styleUrl: './copyable-log-field.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyableLogFieldComponent implements OnDestroy {
  readonly label = input('');
  readonly text = input('');
  readonly heading = input<'h3' | 'h4'>('h4');
  readonly showText = input(true);
  readonly copyLabel = input('Copy');

  readonly copied = signal(false);
  readonly canCopy = computed(() => !!this.text().trim());
  readonly buttonTitle = computed(() => this.copied() ? 'Copied' : this.copyLabel());
  readonly buttonIcon = computed(() => this.copied() ? 'pi pi-check' : 'pi pi-copy');
  readonly isHeading3 = computed(() => this.heading() === 'h3');

  private resetTimer: ReturnType<typeof setTimeout> | null = null;

  copy(): void {
    const value = this.text();
    if (!value.trim() || typeof navigator === 'undefined' || !navigator.clipboard) {
      return;
    }
    void navigator.clipboard.writeText(value).then(() => {
      this.copied.set(true);
      if (this.resetTimer) {
        clearTimeout(this.resetTimer);
      }
      this.resetTimer = setTimeout(() => {
        this.copied.set(false);
        this.resetTimer = null;
      }, 1500);
    });
  }

  ngOnDestroy(): void {
    if (this.resetTimer) {
      clearTimeout(this.resetTimer);
    }
  }
}
